import moment from "moment";

export const TIMESTAMP_FORMATS = {
  // Base formats
  MONTH_SHORT_DATE: 'MMM D, YYYY', // Oct 5, 2025
  MONTH_SHORT_DATE_TIME: 'MMM D YYYY, h:mm A', // Oct 5 2025, 3:45 PM
  MONTH_LONG_DATE: 'MMMM D, YYYY', // October 5, 2025
  MONTH_LONG_DATE_TIME: 'MMMM D YYYY, h:mm A', // October 5, 2025, 3:45 PM
  DATE_ONLY: 'MMM D, YYYY', // Oct 5, 2025
  NUMERIC_DATE_TIME: 'MM-DD-YYYY h:mm a', // 10-05-2025 3:45 pm
  MONTH_DAY: 'MMM D', // Oct 5
  MONTH_DAY_TIME_PIPE_SEPARATED: 'MMM D | h:mm A', // Oct 5 | 3:45 PM
  MONTH_LONG_DATE_TIME_SECONDS: 'MMMM D YYYY h:mm:ss A', // October 5 2025, 3:45:45 PM
  MONTH_DATE_TIME: 'MMMM D, h:mm a',
  TIME_MONTH_DATE_YEAR: 'h:mm a, MMMM D YYYY',
  MONTH_DATE_SHORT_YEAR: 'MMM D YY',

  WEEKDAY_NUMERIC_DATE_TIME_TZ: 'ddd, MM/DD/YYYY, h:mm A z', // Sun, 10/05/2025, 3:45 PM CST

  MONTH_SHORT_DATE_TIME_AMERICAN: 'MMM D, YYYY, h:mm A', // Oct 5, 2025, 3:45 PM

  // Time-only formats
  TIME_12_HOUR_UPPER: 'h:mm A', // 3:45 PM
  TIME_12_HOUR_LOWER: 'h:mm a', // 3:45 pm
};


export const formatCreatedDate = (date) => {
  const now = moment();
  const created = moment(date);
  const hoursDiff = now.diff(created, "hours");

  if (hoursDiff < 24) return "Today";
  if (hoursDiff < 48) return "Yesterday";

  return created.format(TIMESTAMP_FORMATS.MONTH_SHORT_DATE);
};

export const formatLastModified = (date) => {
  const now = moment();
  const modified = moment(date);

  const diffSeconds = now.diff(modified, "seconds");
  const diffMinutes = now.diff(modified, "minutes");
  const diffHours = now.diff(modified, "hours");

  if (diffSeconds < 60) {
    return `${diffSeconds} ${diffSeconds === 1 ? "second" : "seconds"} ago`;
  }

  if (diffMinutes < 60) {
    return `${diffMinutes} ${diffMinutes === 1 ? "min" : "mins"} ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} ${diffHours === 1 ? "hour" : "hours"} ago`;
  }

  if (diffHours < 48) {
    return "Yesterday";
  }

  return modified.format(TIMESTAMP_FORMATS.MONTH_SHORT_DATE);
};